<template>
  <div class="">
    <BgGradation>
      <BaseContainer class="pt16 pb48 ml16">
        <Question
          :headerText="'はじめに登録内容を確認しましょう。'"
          :isFinish="false"
          class="question_component"
        >
        <template #btn>
            <div v-if="isShowStartBtn" class="btn_wrap mt24">
              <BaseBtn
                :disabled="false"
                :btnText="'O K'"
                :type="isStart ? 'blue' : 'unselected'"
                @onClick="onClickIsStart"
              />
            </div>
          </template>
        </Question>
        <template v-if="isStart">
          <div
          class="question_component"
          v-for="(data, i) in questionListDto"
          :key="i"
        >
          <Question
            v-if="showIndexNumber >= i "
            :headerText="data.question"
          >
              <template #btn>
                <div class="btn_wrap column mt24">
                  <BaseBtn
                    :disabled="false"
                    :btnText="'はい'"
                    :type="answerList[i] === true ? 'blue' : 'unselected'"
                    @onClick="onClickCorrectProduct(i, true)"
                  />
                  <BaseBtn
                    :disabled="false"
                    :btnText="'いいえ'"
                    :type="answerList[i] === false ? 'blue' : 'unselected'"
                    @onClick="onClickCorrectProduct(i, false)"
                  />
                </div>
              </template>
          </Question>
        </div>

        <Question
          v-if="questionListDto.length > 0 && showIndexNumber === questionListDto.length"
          :headerText="finalHeaderText"
          :isFinish="true"
          class="question_component mt40"
        >
          <template #btn>
            <div class="btn_wrap mt24">
              <BaseBtn
                :disabled="isCheckConfirmBtn ? false : true"
                :btnText="'確認'"
                :type="isCheckConfirmBtn ? 'blue' : 'unselected'"
                @onClick="onClickConfirm"
              />
            </div>
          </template>
        </Question>
        </template>

      </BaseContainer>
    </BgGradation>
    <BaseModal
      v-if="isConfirmModal"
      @closeModal="closeModal()"
    >
      <h3 class="modal_title rb">{{ modalText }}</h3>
      <div class="modal_btn_wrap mt48">
        <BaseBtn
          :disabled="false"
          :btnText="'送信'"
          :type="'blue'"
          @onClick="onClickSubmit"
        />
        <div class="mt25"></div>
        <BaseBtn
          :disabled="isConfirm ? false : true"
          :btnText="'戻る'"
          :type="'delete'"
          @onClick="closeModal()"
        />

      </div>
    </BaseModal>
  </div>
</template>

<script>
import BgGradation from '@/components/common/BgGradation.vue';
import BaseContainer from '@/components/common/BaseContainer.vue';
import BaseBtn from "@/components/common/BaseBtn.vue";
import BaseModal from "@/components/common/BaseModal.vue";
import Question from "@/components/welcomeCall/Question.vue";
import Config from '@/config/config'
import WelcomeCall from '@/components/api/welcomeCall/index.js';

export default {
  components: {
    BgGradation,
    BaseContainer,
    BaseBtn,
    Question,
    BaseModal
  },
  data() {
    return {
      isShowStartBtn: false,
      isStart: false,
      isConfirm: true,
      isConfirmModal: false,
      questionListDto: [],
      answerList: [],
      modalText: '',
      showIndexNumber: 0,
      finalHeaderText: `ひとつでも「いいえ」をご選択いただいた場合、後日弊社より確認のためお電話を差し上げます。<br>今後ともよろしくお願い申し上げます。<br><br><div class="center">【お問い合わせ】<br>無料ダイヤル <a href="tel:0120-989-329">0120-989-329</a><br>受付時間 平日10時～18時<br>(土・日・祝日休み)</div>`,
    }
  },
  methods: {
    onClickIsStart() {
      this.isStart = true;
    },
    onClickConfirm() {
      this.modalText = '選択した内容でよろしければ、送信ボタンを押してください。';
      this.isConfirmModal = true;
    },
    closeModal() {
      this.isConfirmModal = false;
    },
    onClickCorrectProduct(index, answer) {
      if (this.showIndexNumber <= index) {
        this.showIndexNumber = index + 1;
      }
      this.$set(this.answerList, index, answer);
    },
    async onClickSubmit() {
      const result = await this.apiRegisterWelcomeCallAnswer();
      if(result === 'OK') {
        // GettingStartへ遷移
        this.$router.push({ name: 'WelcomeCallGettingStart' });
      }
      this.modalText = '送信できませんでした。再度お試しください。';
    },

    createRequestData() {
      let requestData = {
        allOk: false,
        content: ''
      }
      // questionListDtoのquestionとanswerListを結合して、contentに追加
      for (let i = 0; i < this.questionListDto.length; i++) {
        requestData.content += this.questionListDto[i].question + '：' + (this.answerList[i] ? 'はい' : 'いいえ') + '\n' + '\n';
      }

      // answerListに1つでもfalseがあれば、allOkをfalseにする
      if (this.answerList.some((answer) => answer === false)) {
        requestData.allOk = false;
      } else {
        requestData.allOk = true;
      }

      return requestData;
    },

    async apiRegisterWelcomeCallAnswer() {
      // this.answerListに1つでもnullがあれば、return false
      if (!this.isCheckConfirmBtn) return false;

      const requestData = this.createRequestData();
      const result = await WelcomeCall.registerWelcomeCallAnswer(requestData).then((res) => {
        return res;
      });

      return result
    }
  },
  computed: {
    isCheckConfirmBtn() {
      // nullがなければtrue
      return !this.answerList.some((answer) => answer === null);
    }
  },
  created() {
    this.isStart = false;
    this.isShowStartBtn = false;
    WelcomeCall.getWelcomeCallQuestion().then((res) => {
      this.isShowStartBtn = true;
      this.questionListDto = res.questionListDto;
      // res.questionListDtoの長さ分、answerListにnullを追加
      for (let i = 0; i < res.questionListDto.length; i++) {
        this.answerList.push(null);
      }
    })
  }
};
</script>

<style lang="css" scoped>
.btn_wrap.column {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.question_component:not(:first-child) {
  margin-top: 44px;
}

.modal_title {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/welcomeCall/Question.vue